const type = {
    Tier1: 1,
    Tier2: 2,
    Tier3: 3,
    Area_Organization: 4,
    TTS: 90,
    QBTS: 99,
    QTHT: 100,
}

const ListRoles = [
    {
        type: type.QTHT,
        name: 'Quản trị hệ thống',
    },
    {
        type: type.QBTS,
        name: 'Quân báo trinh sát',
    },
    {
        type: type.TTS,
        name: 'Trung tâm trinh sát',
    },
    {
        type: type.Tier1,
        name: 'Tier 1',
    },
    {
        type: type.Tier2,
        name: 'Tier 2',
    },
    {
        type: type.Tier3,
        name: 'Tier 3',
    },
    {
        type: type.Area_Organization,
        name: 'Người dùng đơn vị vùng',
    },
]

export default ListRoles
